<template>

  <div>
    <files-list :files="files" @upload="upload($event)" @remove="remove($event)"></files-list>
  </div>

</template>

<script>
  import FilesList from '../../files/components/files-list'

  export default {
    name: 'intervention-files',

    props: [ 'intervention' ],

    computed: {
      files () {
        return this.intervention.filesInInterventions.map(file => file.file)
      },
    },

    methods: {
      async upload (file) {
        const formData = new FormData()
        formData.append('file', file)

        const response = await this.$store.dispatch('uploadFile', {
          modelName: 'intervention',
          modelItemId: this.intervention.id,
          formData: formData,
          resize: true
        })

        this.$emit('change', response.data)
      },

      remove (id) {
        const file = this.intervention.filesInInterventions.find(file => file.fileId === id)
        this.$emit('remove', file.id)
      }
    },

    components: {
      FilesList
    }
  }
</script>

<style scoped lang="scss">

</style>
